import { type JSX } from "react";
import { OfferEditableWrap } from "@/components/ClientOfferView";
import styles from "@/components/ClientOfferView.module.css";
import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";

export function ExclusionsSection({
  offerData,
  onExclusionsChange,
}: OfferSectionProps): JSX.Element | null {
  const items = (offerData.exclusions ?? []).map((item) => item.trim()).filter(Boolean);
  const onChange = onExclusionsChange ?? offerData.onExclusionsChange;
  if (items.length === 0) return null;

  const updateItem = (idx: number, value: string) => {
    const trimmed = value.trim();
    const next = items.filter((_, itemIdx) => itemIdx !== idx);
    if (trimmed) next.splice(idx, 0, trimmed);
    onChange?.(next.length > 0 ? next : undefined);
  };

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Wyłączenia
          <br />
          odpowiedzialności
        </h2>
      </div>
      <ul className={styles.assumptionsList}>
        {items.map((item, idx) => (
          <li key={`${item}-${idx}`} className={styles.assumptionItem}>
            <span className={styles.assumptionBullet}>{String(idx + 1).padStart(2, "0")}</span>
            {onChange ? (
              <OfferEditableWrap enabled className={styles.assumptionEditableWrap}>
                <span
                  contentEditable
                  spellCheck={false}
                  suppressContentEditableWarning
                  onBlur={(e) => updateItem(idx, e.currentTarget.textContent ?? "")}
                >
                  {item}
                </span>
              </OfferEditableWrap>
            ) : (
              <span>{item}</span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
